// extracted by mini-css-extract-plugin
export default {"banner":"CookieConsent_banner__aMIw8","actions":"CookieConsent_actions__b4yy0","primary":"CookieConsent_primary__lRuZC","secondary":"CookieConsent_secondary__SEYoE"};